import { Component, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

/** `undefined` when the user exits; otherwise whether to skip this warning in the future. */
export type ExternalPasteDialogResult = { remember: boolean } | undefined;

@Component({
  selector: 'wk-external-paste-warning-dialog',
  templateUrl: './wk-external-paste-warning-dialog.component.html',
  styleUrls: ['./wk-external-paste-warning-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class WKExternalPasteWarningDialogComponent {
  public rememberChoice = false;
  constructor(
    private readonly dialogRef: MatDialogRef<
      WKExternalPasteWarningDialogComponent,
      ExternalPasteDialogResult
    >
  ) {}

  public exit(): void {
    this.dialogRef.close();
  }

  public pasteAsPlainText(): void {
    this.dialogRef.close({ remember: this.rememberChoice });
  }
}
